import QRCode from "qrcode";

function findBreakPoint(text, width, context) {
  let min = 0;
  let max = text.length - 1;

  while (min <= max) {
    const middle = Math.floor((min + max) / 2);
    const middleWidth = context.measureText(text.substr(0, middle)).width;
    const oneCharWiderThanMiddleWidth = context.measureText(
      text.substr(0, middle + 1)
    ).width;
    if (middleWidth <= width && oneCharWiderThanMiddleWidth > width) {
      return middle;
    }
    if (middleWidth < width) {
      min = middle + 1;
    } else {
      max = middle - 1;
    }
  }

  return -1;
}

function breakLinesForCanvas(ctx, text, width) {
  const result: string[] = [];
  let breakPoint = 0;

  while ((breakPoint = findBreakPoint(text, width, ctx)) !== -1) {
    result.push(text.substr(0, breakPoint));
    text = text.substr(breakPoint);
  }

  if (text) {
    result.push(text);
  }

  return result;
}

export function genInviteImage(
  vue: Vue,
  code: string,
  link: string,
  callback: Function
) {
  const canvas = document.createElement("canvas");

  const rw = 375;
  const rh = 760;
  const radio = 375 / 760;
  const dpr = devicePixelRatio || 1;

  const cw = rw / rh > radio ? rw : rh * radio;
  const ch = rw / rh > radio ? rw / radio : rh;

  canvas.width = cw * dpr;
  canvas.height = ch * dpr;

  canvas.style.width = cw + "px";
  canvas.style.height = ch + "px";
  canvas.style.letterSpacing = 10 + "px";

  const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
  ctx.scale(dpr, dpr);

  ctx.fillStyle = "#262C36";
  ctx.fillRect(0, 0, cw, ch);

  const background = new Image();
  background.src =
    vue.$i18n.locale === "en"
      ? require("@/assets/images/invite_bg_en.png")
      : require("@/assets/images/invite_bg_zh.png");
  background.onload = async () => {
    ctx.drawImage(background, 0, 0, cw, ch);

    ctx.font = "32px bold DINPro";
    ctx.fillStyle = "#EF8343";
    ctx.textAlign = "center";
    const codeText = code
      .split("")
      .map((char, index) => (index === 0 ? char : " " + char))
      .join("");
    ctx.fillText(codeText, cw / 2, (420 / 760) * ch);

    ctx.font = "14px Heiti SC";
    ctx.fillStyle = "#727982";
    ctx.textAlign = "center";
    const l1 = vue.$t("invite.referral-label-1");
    const l1_Y = (460 / 760) * ch;
    const l1_W = cw * 0.6;
    breakLinesForCanvas(ctx, l1, l1_W).forEach((t, i) => {
      ctx.fillText(t, cw / 2, l1_Y + i * 20, l1_W);
    });

    const l2 = vue.$t("invite.referral-label-2");
    const l2_Y = (650 / 760) * ch;
    const l2_W = (cw * 2) / 3;
    breakLinesForCanvas(ctx, l2, l2_W).forEach((t, i) => {
      ctx.fillText(t, cw / 2, l2_Y + i * 20, l2_Y);
    });

    function down() {
      callback(canvas.toDataURL("image/png"));
    }

    // draw qrcode
    const qrcode = new Image();
    qrcode.src = await QRCode.toDataURL(link);
    qrcode.onload = () => {
      const x = (cw - 120) / 2;
      const y = (500 / 760) * ch;
      ctx.drawImage(qrcode, x, y, 120, 120);
      down();
    };
  };
}
